<template>
  <div class="content_main">
    <p class="content_normal">We are solicitors to Flypay loan application. You are receiving this
      notice because a pre-litigation file has been opened in your name. Our agent reported your
      fishy and frustrating activities and we have taken records of shreds of evidence from time to
      time when you are being contacted. Because you have failed to comply with the terms and
      conditions in which this loan was disbursed to you, we have reserved the right to take up
      charges against you in your name. From now on, we will send your details to the law-protecting
      bodies for a check on your work unit, relatives, and business information. If the charges
      against you are passed, the following action will be taken against you:</p>
    <br />
    <p class="content_normal">1. Your BVN will be blacklisted </p>
    <p class="content_normal">2. A lien will be placed on your bank account</p>
    <p class="content_normal">3. We will file for a total ban on your profile from the credit bureau
      so that other loan companies can be aware of your attitude.</p>
    <p class="content_normal">4. Our legal department will summon you to court.</p>
    <br />
    <p class="content_normal">It is not our practice to exhibit actions such as this but our company
      cannot afford to incur a further loss that will ruin the company completely. Kindly give the
      necessary cooperation in order to be able to help you. </p>
    <br />
    <p class="content_normal">If you are experiencing difficulty to repay, our company can waive the
      late payment fee of 30% and lets you repay the outstanding. Kindly respond to our recovery
      officers or contact: </p>
    <br />
    <p class="content_normal">WhatsApp-09120482700</p>
    <p class="content_normal">Email- collection@flypay.ng</p>
    <br />
    <p class="content_normal">This letter requires you to give an immediate response.</p>
    <br />
    <p class="content_normal">While waiting for your prompt reply, do have the assurance our best
      wishes.</p>
    <br />
    <p class="content_normal">Best regards</p>

  </div>
</template>

<script>
export default {
  name: 'flypayM2',
};
</script>


<style lang="stylus" scoped>
px = (1 / 24.75vw);
.content {
  padding: 25 *px 16 *px;

  .content_main {
    line-height: 20px;
    text-indent: 16px;
    margin-top: 16px;
  }

  .content_normal {
    text-align: left;
    text-indent: 16px;
  }
}
</style>
